import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './components/app/app'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { BrowserRouter } from 'react-router-dom'
import store from './redux/store'
import './assets/styles/index.scss'


// import { PersistGate } from 'redux-persist/integration/react'
// import Loader from './components/loader/loader.coponent'
// import store, { persistor } from './redux/store'
// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <PersistGate loading={<Loader />} persistor={persistor}>
//         <BrowserRouter>
//           <App />
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   </React.StrictMode>
// )


// @ts-ignore
window.store = store // DEV ONLY

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
   <Provider store={store}>
      <BrowserRouter>
         <App />
      </BrowserRouter>
   </Provider>
)

serviceWorkerRegistration.register()
